/*! Pay in 4 installments - adapted for DTW/Motion theme */
(function() {
  'use strict';

  function PayIn4(el) {
    this.el = el;
    this.installments = Math.max(1, Number(el.dataset.installments) || 4);
    this.moneyFormat = el.dataset.moneyFormat || (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    try {
      this.variantPrices = JSON.parse(el.dataset.variantPrices || '{}');
    } catch (e) {
      this.variantPrices = {};
    }
    this.amountEl = el.querySelector('[data-pay-in-4-amount]');
    this.trigger = el.querySelector('.pay-in-4__info-trigger');
    this.tooltip = el.querySelector('.pay-in-4__tooltip');

    this._onVariantChange = this._onVariantChange.bind(this);
    this._onTriggerClick = this._onTriggerClick.bind(this);
    this._onDocClick = this._onDocClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);

    this._init();
  }

  PayIn4.prototype._init = function() {
    // Tooltip click-toggle
    if (this.trigger && this.tooltip) {
      this.trigger.addEventListener('click', this._onTriggerClick);
      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onKeydown);
    }

    // Listen to variant changes on the document level (DTW dispatches 'variant:change')
    document.addEventListener('variant:change', this._onVariantChange);
  };

  PayIn4.prototype.destroy = function() {
    if (this.trigger && this.tooltip) {
      this.trigger.removeEventListener('click', this._onTriggerClick);
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onKeydown);
    }
    document.removeEventListener('variant:change', this._onVariantChange);
  };

  PayIn4.prototype._setTooltipOpen = function(open) {
    if (!this.tooltip || !this.trigger) return;
    if (open) {
      this.tooltip.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
    } else {
      this.tooltip.setAttribute('hidden', '');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  };

  PayIn4.prototype._onTriggerClick = function(event) {
    event.preventDefault();
    event.stopPropagation();
    var isOpen = !this.tooltip.hasAttribute('hidden');
    this._setTooltipOpen(!isOpen);
  };

  PayIn4.prototype._onDocClick = function(event) {
    if (!this.tooltip || this.tooltip.hasAttribute('hidden')) return;
    if (this.el.contains(event.target)) return;
    this._setTooltipOpen(false);
  };

  PayIn4.prototype._onKeydown = function(event) {
    if (event.key === 'Escape' && this.tooltip && !this.tooltip.hasAttribute('hidden')) {
      this._setTooltipOpen(false);
      if (this.trigger) this.trigger.focus();
    }
  };

  PayIn4.prototype._onVariantChange = function(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !this.amountEl) return;
    var price = this.variantPrices[variant.id] !== undefined ? this.variantPrices[variant.id] : variant.price;
    if (typeof price !== 'number') return;
    var perInstallment = Math.floor(price / this.installments);
    this.amountEl.innerHTML = theme.Currency.formatMoney(perInstallment, this.moneyFormat);
  };

  // Auto-initialize all pay-in-4 elements on the page
  function initAll() {
    var elements = document.querySelectorAll('.pay-in-4');
    for (var i = 0; i < elements.length; i++) {
      if (!elements[i]._payIn4Instance) {
        elements[i]._payIn4Instance = new PayIn4(elements[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after theme editor section load
  document.addEventListener('shopify:section:load', function() {
    initAll();
  });
})();
